import React, { useState, useEffect } from "react";
import ProductDescription from "./ProductDescription";
import ProductDetail from "./ProductDetail";
import ProductImageSlider from "./ProductImageSlider";
import ProductRecommendations from "./ProductRecommendations";
import ProductReviews from "./ProductReviews";
import ShoppingFeatures from "./ShoppingFeatures";

const MainProductArea = React.memo(({ product }) => {
  const [isOnSale, setIsOnSale] = useState(false);
  const [isInStock, setIsInStock] = useState(true);

  useEffect(() => {
    if (product) {
      setIsOnSale(
        product.compareAtPrice && product.price < product.compareAtPrice
      );

      setIsInStock(
        product.inventory.quantity > 0 ||
          product.inventory.policy === "continue"
      );
    }
  }, [product]);

  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <ProductImageSlider
                  product={product}
                  isInStock={isInStock}
                  isOnSale={isOnSale}
                />

                <ProductDetail
                  product={product}
                  isInStock={isInStock}
                  isOnSale={isOnSale}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <ProductDescription product={product} />

      <ProductRecommendations product={product} />

      <ProductReviews product={product} />

      <ShoppingFeatures />
    </>
  );
});

export default MainProductArea;
